import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx'

import { UserPermissions } from './types.ts'
import { IconName } from '@/assets/icons'

export const CONTENT_WIDTH = 1360
export const CONTENT_WIDTH_WITh_NAVIGATION_PANEL = 1200
export const CONTENT_PADDING = { xs: 2, xl: 0 }
export const COMPANY_PHONES = ['+7 495 249 11 62', '8 800 302 92 29']
export const HELP_EMAIL = 'help@cifra-bank.ru'
export const PR_EMAIL = 'pr@cifra-bank.ru'

export const EMPTY_VALUE = '—'

export const WIDTH_NAVIGATION_PANEL_IN_PIXEL = 300

// generatePath
export const APP_ROUTES = {
  Login: '/login',
  Restore: '/restore',
  ChangePassword: '/changepassword',

  SbpPayments: '/sbp',
  SbpPaymentView: '/sbp/view/:id',

  TemplatePayments: '/templates',
  TemplatePaymentView: '/templates/view/:id',

  C2BQrs: '/c2b',
  B2BQrs: '/b2b',

  B2C: '/b2c',
  B2CView: '/b2c/view/:id',
  B2CRegistry: '/b2c/registry/:id',

  AcqPayments: '/acquiring',
  AcqPaymentsView: '/acquiring/view/:id',

  OperationRequests: '/operation-requests',
} as const

export const PERMISSION_ROUTES_MAP: Partial<Record<keyof UserPermissions, Array<string>>> = {
  showSbp: [APP_ROUTES.SbpPayments],
  showQrB2b: [APP_ROUTES.B2BQrs],
  showOneTimePage: [APP_ROUTES.OperationRequests],
  showAcqOperations: [APP_ROUTES.AcqPayments],
  showStaticTemplate: [APP_ROUTES.TemplatePayments],
  showB2c: [APP_ROUTES.B2C],
}

export const APP_TITLES: Record<string, string> = {
  [APP_ROUTES.Login]: 'Цифра | Вход в личный кабинет СБП юридического лица',
  [APP_ROUTES.Restore]: 'Цифра | Восстановление пароля',
  [APP_ROUTES.ChangePassword]: 'Цифра | Изменение пароля',

  [APP_ROUTES.SbpPayments]: 'Цифра | Мониторинг операций СБП',
  [APP_ROUTES.SbpPaymentView]: 'Цифра | Мониторинг операций СБП',

  [APP_ROUTES.TemplatePayments]: 'Цифра | Статические страницы оплаты',
  [APP_ROUTES.TemplatePaymentView]: 'Цифра | Статические страницы оплаты',

  [APP_ROUTES.B2BQrs]: 'Цифра | Переводы контрагентам (В2В)',
  [APP_ROUTES.C2BQrs]: 'Цифра | Переводы от физ. лиц (С2В)',
  [APP_ROUTES.B2C]: 'Цифра | Переводы физ. лицам (В2С)',
  [APP_ROUTES.B2CView]: 'Цифра | Переводы физ. лицам (В2С)',

  [APP_ROUTES.OperationRequests]: 'Цифра | Разовые страницы оплаты',
  [APP_ROUTES.AcqPayments]: 'Цифра | Операции эквайринга',
  [APP_ROUTES.AcqPaymentsView]: 'Цифра | Операции эквайринга',
}

const PERMISSION_MENU_MAP: Partial<Record<keyof UserPermissions, MenuItem>> = {
  showSbp: { href: APP_ROUTES.SbpPayments, title: 'Мониторинг операций СБП' },
  showQrB2b: { href: APP_ROUTES.B2BQrs, title: 'Переводы контрагентам (В2В)' },
  showQrC2b: { href: APP_ROUTES.C2BQrs, title: 'Переводы от физ. лиц (С2В)' },
  showQrC2bStatic: { href: APP_ROUTES.C2BQrs, title: 'Переводы от физ. лиц (С2В)' },
  showB2c: { href: APP_ROUTES.B2C, title: 'Переводы физ. лицам (В2С)' },
  showOneTimePage: { href: APP_ROUTES.OperationRequests, title: 'Разовые страницы оплаты' },
  showAcqOperations: { href: APP_ROUTES.AcqPayments, title: 'Операции эквайринга' },
  showStaticTemplate: { href: APP_ROUTES.TemplatePayments, title: 'Статические страницы оплаты' },
}

const NAVIGATION_MENU_ORDER: Partial<Record<keyof typeof APP_ROUTES, (keyof UserPermissions)[]>> = {
  C2BQrs: ['showQrC2b', 'showQrC2bStatic'],
  B2BQrs: ['showQrB2b'],
  B2C: ['showB2c'],
  SbpPayments: ['showSbp'],
  AcqPayments: ['showAcqOperations'],
  OperationRequests: ['showOneTimePage'],
  TemplatePayments: ['showStaticTemplate'],
}

export const NAVIGATION_MENU_ICON: Record<string, IconName> = {
  [APP_ROUTES.C2BQrs]: 'C2BOperation',
  [APP_ROUTES.B2BQrs]: 'B2BOperation',
  [APP_ROUTES.B2C]: 'B2COperation',
  [APP_ROUTES.SbpPayments]: 'SbpOperation',
  [APP_ROUTES.AcqPayments]: 'AcqOperation',
  [APP_ROUTES.OperationRequests]: 'OneTimePaymentPage',
  [APP_ROUTES.TemplatePayments]: 'StaticPaymentPage',
}

export interface MenuItem {
  href: string
  title: string
}

export const DASHBOARD_MENU = (permissions: UserPermissions): Array<MenuItem> => {
  const menuMap = new Map<string, MenuItem>()

  Object.entries(NAVIGATION_MENU_ORDER).forEach(([, permissionsList]) => {
    if (permissionsList.some((e) => permissions[e])) {
      const menuItem = PERMISSION_MENU_MAP[permissionsList[0]]
      if (menuItem) {
        menuMap.set(menuItem.href, menuItem)
      }
    }
    return
  })

  return Array.from(menuMap.values())
}

export const CONTENT_WRAPPER_SX: SystemStyleObject = {
  maxWidth: CONTENT_WIDTH,
  px: CONTENT_PADDING,
  margin: '0 auto',
  mt: 4,
}

export const CONTENT_WRAPPER_SX_PC: SystemStyleObject = {
  width: '100%',
  maxWidth: CONTENT_WIDTH,
  px: 2,
  mt: 4,
}
